import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`
        py-16 md:py-24 px-6 md:px-8 w-full
        ${dark ? 'bg-[#F0EBE0]' : 'bg-[#FAF7F2]'}
        ${className}
      `} data-id="element-162">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto" data-id="element-163">
        {children}
      </motion.div>
    </section>;
}